import { render, staticRenderFns } from "./responsive-text.vue?vue&type=template&id=a9648e3e&lang=pug&"
import script from "./responsive-text.vue?vue&type=script&lang=js&"
export * from "./responsive-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports